
// @ts-nocheck


export const localeCodes =  [
  "ru",
  "en",
  "es",
  "ab",
  "tr",
  "ar"
]

export const localeLoaders = {
  "ru": [],
  "en": [],
  "es": [],
  "ab": [],
  "tr": [],
  "ar": []
}

export const vueI18nConfigs = [
  () => import("../utils/i18n.config.ts?hash=5f8055ae&config=1" /* webpackChunkName: "@_utils_i18n_config_ts_5f8055ae" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "@/utils/i18n.config.ts",
  "locales": [
    {
      "code": "ru"
    },
    {
      "code": "en"
    },
    {
      "code": "es"
    },
    {
      "code": "ab"
    },
    {
      "code": "tr"
    },
    {
      "code": "ar"
    }
  ],
  "defaultLocale": "ru",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ru",
    "files": []
  },
  {
    "code": "en",
    "files": []
  },
  {
    "code": "es",
    "files": []
  },
  {
    "code": "ab",
    "files": []
  },
  {
    "code": "tr",
    "files": []
  },
  {
    "code": "ar",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
